import { createSlice } from '@reduxjs/toolkit';

export const videoChatSlice = createSlice({
  name: 'videoChat',
  initialState: {
    meetingSession: null,
    users: {},
    isRecording: false,
    // Current face-effect set per participant, keyed by Lixani user id
    // (= Chime ExternalUserId). Each entry is written only from its owner's
    // authoritative 'state' broadcasts; `ts` is the broadcast's server
    // timestamp, used to drop out-of-order updates.
    participantEffects: {},
  },
  reducers: {
    setMeetingSession: (state, action) => {
      state.meetingSession = action.payload;
    },
    setIsRecording: (state, action) => {
      state.isRecording = action.payload;
    },
    setParticipantEffects: (state, action) => {
      const { userId, effects, ts } = action.payload;
      const existing = state.participantEffects[userId];
      if (existing && existing.ts && ts && ts < existing.ts) {
        return;
      }
      state.participantEffects[userId] = { effects, ts };
    },
    removeParticipantEffects: (state, action) => {
      delete state.participantEffects[action.payload];
    },
    resetParticipantEffects: (state) => {
      state.participantEffects = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase('videoChat/joinSession/fulfilled', (state, action) => {
        state.meetingSession = action.payload;
      })
      .addCase('videoChat/loadUsers/fulfilled', (state, action) => {
        state.users = { ...state.users, ...action.payload };
      });
  },
});
// ACTIONS
export const {
  setMeetingSession,
  setIsRecording,
  setParticipantEffects,
  removeParticipantEffects,
  resetParticipantEffects,
} = videoChatSlice.actions;
// SELECTORS
export const getVideoChatControlData = (state) => {
  return state.videoChatSlice;
};
// Stable empty array so components using this selector do not re-render for
// participants that have no effects.
const EMPTY_EFFECTS = [];
export const selectParticipantEffects = (state, userId) =>
  state.videoChatSlice.participantEffects[userId]?.effects || EMPTY_EFFECTS;
